import { memo } from 'react';

import { Container } from './styles';

function InfoNew() {
  return <Container>Novo</Container>;
}

export default memo(InfoNew);
